import React from 'react'
import { ModalBody } from 'reactstrap'
import { Eeocs } from 'src/queries'
import { DescriptionList, Item, ItemProps } from 'src/components/DescriptionList'
import { getDocumentData } from '../../../helpers'

interface BodyProps {
  data: Eeocs[0] | undefined
}

const Body: React.FC<BodyProps> = (props) => {
  const { data } = props
  if (data === undefined) {
    return null
  }
  const section: Array<Omit<ItemProps, 'id'>> = [
    {
      title: 'Gender Identification',
      value: getDocumentData('Gender Identification')(data)
    },
    {
      title: 'Race / Ethnic Identification',
      value: getDocumentData('Race / Ethnic Identification')(data)
    },
    {
      title: 'Address',
      value: getDocumentData('Address')(data)
    },
    {
      title: 'Disablity',
      value: getDocumentData('Disablity')(data)
    },
    {
      title: 'Protected Veteran',
      value: getDocumentData('Protected Veteran')(data)
    }

  ]
  const dlProps = {
    className: 'row-cols-1',
    suspended: data === undefined,
    titleProps: { lg: 'auto' },
    valueProps: { lg: 'auto', className: 'mb-lg-0 mb-md-1 mb-3' }
  }
  return (
    <>
      <ModalBody>
        <DescriptionList {...dlProps}>
          {section.map(item => {
            const key = item.title.toLowerCase().replace(' ', '-')
            return <Item {...item} key={key} id={key} />
          })}
        </DescriptionList>
      </ModalBody>
    </>
  )
}

export default Body
